/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export default function Button (theme) {
    const disabledStyle = {
        "&.Mui-disabled": {
            backgroundColor: "#CFCFCF",
            color: theme.palette.grey[500],
        },
    };
    const containedSVGStyle = {
        "&.MuiButton-contained svg path": {
            fill: "white",
        },
        "&.MuiButton-contained.Mui-disabled svg path": {
            fill: theme.palette.grey[500],
        },
    };

    return {
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
            styleOverrides: {
                contained: {
                    ...disabledStyle,
                    ...containedSVGStyle,
                },
                root: {
                    fontWeight: 400,
                },
                outlined: {
                    ...disabledStyle,
                },
            },
        },
    };
}
